import actions from "./actions";
import atoms from "./atoms";
import selectors from "./selectors";

export const COMMON_LAYOUT_ATOMS = atoms;
export const COMMON_LAYOUT_SELECTORS = selectors;
export const COMMON_LAYOUT_ACTIONS = actions;
